export class Question {
  id: string;
  documentId: string;
  clientId: string;
  question: string;
  answers: Array<any> = [];
  name: string;
}

export class Answer {
  title: string;
  isCorrect: boolean;
}
